import ModalFactory from '../factory';

import Content from './SettingsModal';

const SettingsModal = ModalFactory(Content);

export default SettingsModal;
